import "./App.css";
import axios from "axios";
import { useEffect, useRef, useState, useContext } from "react";
import Alert from "./Alert";
import LoadingAnimation from "./loading-animation";
import { Form } from "@bpmn-io/form-js";
import { Button } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import ConfirmationDialogRaw from "./Components/ConfirmDialog";
import { ApiUrl } from "./API";
import Warning from "./Warning";
import { MyContext } from "./Context";
function App() {
  const [display, setDisplay] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [searchParams] = useSearchParams();
  const [showloader, setShowloader] = useState(false);
  const [showDialog, setshowDialog] = useState(false);
  const [element, setelement] = useState({});
  const [formVar, setformVar] = useState({});
  const [SchemaPathName, setSchemaPathName] = useState({});
  const [formSchemaData, setformSchemaData] = useState({});
  const [InstanceKey, setInstanceKey] = useState("");
  const [DefinationKey, setDefinationKey] = useState("");
  const [Authorizationtoken, setAuthorizationtoken] = useState("");
  const [dataobj, setdataobj] = useState({});
  const [showExit, setshowExit] = useState(false);
  const [displayWarning, setdisplayWarning] = useState(false);
  const { sharedData, setSharedData, countdata } = useContext(MyContext);
  const [showretry, setshowretry] = useState(false);
  // let Authorizationtoken = '';
  let form = useRef({});
  const ObjRef = useRef({});
  const OrgSalary = useRef({});
  const completeTaskObj = useRef({});
  let SchemaPathNameDate = useRef({});
  var token;
  var featurename;
  var bankcode;
  const getfeature = (featurename, bankcode) => {
    setShowloader(true);
    return axios.post(
      `${ApiUrl.GetFeature}`,
      {
        bankcode: bankcode,
        feature_name: featurename,
      },
      {
        headers: {
          Authorization: `${sessionStorage.getItem("CORESESSION")}`,
        },
      },
    );
  };
  const startprocessinstance = (workflowid) => {
    axios
      .post(
        `${ApiUrl.StartProcess}`,
        {
          applicationSource: "web3.0",
          bpmnId: workflowid,
        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem("CORESESSION")}`,
          },
        },
      )
      .then((respdata) => {
        let schemadata = respdata.data.items[0];
        if (schemadata) {
          getformschema(
            schemadata.processDefinitionKey,
            schemadata.processInstanceKey,
            undefined,
          );
        }
      })
      .catch((err) => {
        setShowloader(false);
        setdisplayWarning(true);
        setMessage("MSG");
      });
  };
  const closediv = () => {
    exit();
    setDisplay(false);
  };
  const closeWarning = (isexit) => {
    if (isexit) {
      exit();
    } else {
      setdisplayWarning(false);
    }
  };

  const exit = () => {
    document.getElementById("home_btn").click();
  };
  var startBtn;
  var saveNext;
  var submitBtn;
  // const [submitBtndata,setsubmitBtndata]=useState(undefined);
  let submitBtndata = useRef({});
  var backBtn;
  var homeBtn;
  const getformschema = (DefinitionKey, InstanceKey, status = 0) => {
    setDefinationKey(DefinitionKey);
    setInstanceKey(InstanceKey);
    var toSub;
    if (status == 0) {
      toSub = axios.post(
        `${ApiUrl.FormSchema}${InstanceKey}`,
        {
          processDefinitionKey: DefinitionKey,
        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem("CORESESSION")}`,
          },
        },
      );
    }
    if (status == 1) {
      console.log(submitBtn);
      console.log(ObjRef.current);
      toSub = Promise.resolve({
        form: formSchemaData,
        var: { ...ObjRef.current },
      });
    }
    toSub
      .then(async (schemaresp) => {
        console.log(form);

        let schemadata = status == 0 ? schemaresp.data : schemaresp;
        console.log(schemadata);
        setformSchemaData(schemadata.form);
        setSchemaPathName(schemadata.form.components[0].path);
        SchemaPathNameDate.current = schemadata.form.components[0].path;
        console.log();
        setformVar(schemadata.var);
        await form.current.importSchema(schemadata.form, schemadata.var || {});
        // console.log(form.getValues());
        // handleUppercaseInputs(schemadata);
        form.current.on("changed", (event) => {
          setformVar(event.data);
          setTimeout(() => {
            handleUppercaseInputs(schemadata);
          }, 400);
        });

        if (schemadata.var.apiLeadResponse) {
          if (
            schemadata.var.apiLeadResponse &&
            schemadata.var.apiLeadResponse.status == 3
          ) {
            setshowretry(true);
            setMessage(schemadata.var.apiLeadResponse.data.errorMessage);
          } else {
            setStatus(schemadata.var.apiLeadResponse.status);
            setDisplay(true);
            setdataobj(schemadata.var.apiLeadResponse.data);
          }
        }
        if (status == 0) {
          const btns = document.getElementsByTagName("button");
          let arrData = [...schemadata.form.components[0].components];
          let ElasticList = [];
          arrData.forEach((data) => {
            if (data.properties && data.properties.elasticsearch == "true") {
              ElasticList.push(data);
            }
            if (data.properties && data.properties.placeholder !== "") {
              const inputsElement = document.getElementsByTagName("input");
              for (let i = 0; i < inputsElement.length; i++) {
                if (inputsElement[i].id.includes(data.id)) {
                  if (data.type == "select") {
                    inputsElement[i].setAttribute("readonly", "true");
                  }
                  inputsElement[i].placeholder = data.properties.placeholder;
                }
              }
            }
            // if(data.type == 'textfield' && data.properties && data?.properties?.letterCase){
            //   const inputsforUpper = document.getElementsByTagName('input');
            //   for (let i = 0; i < inputsforUpper.length; i++) {
            //     if (inputsforUpper[i].id.includes(data.id)) { console.log(inputsforUpper[i])
            //       inputsforUpper[i].addEventListener('input', (event) => {
            //         console.log(event.target.value);
            //         if (data?.properties?.letterCase === 'upper') {
            //           console.log(event.target.value.toUpperCase());
            //           let upperdata=event.target.value.toUpperCase();
            //           console.log(document.getElementById(inputsforUpper[i].id));
            //           // document.getElementById(inputsforUpper[i].id).setAttribute('value',event.target.value.toUpperCase());
            //             // inputsforUpper[i].value = event.target.value.toUpperCase();
            //             console.log('added');

            //         }
            //       });
            //     }
            //   }
            // }
            if (data.properties && data.properties.allowOnly == "number") {
              const inputsElement2 = document.getElementsByTagName("input");
              for (let i = 0; i < inputsElement2.length; i++) {
                if (inputsElement2[i].id.includes(data.id)) {
                  inputsElement2[i].type = "tel";
                }
              }
            }
            if (data.properties && data.properties.maxLength) {
              const inputsElement2 = document.getElementsByTagName("input");
              for (let i = 0; i < inputsElement2.length; i++) {
                if (inputsElement2[i].id.includes(data.id)) {
                  inputsElement2[i].maxLength = data.properties.maxLength;
                }
              }
            }
          });
          let elementlist = [];
          for (let i = 0; i < ElasticList.length; i++) {
            console.log(ElasticList[i].id);
            const elements = [
              ...document.querySelectorAll(`[id$="${ElasticList[i].id}"]`),
            ];
            elementlist.push({ key: ElasticList[i].key, elements });
          }
          for (let i = 0; i < elementlist.length; i++) {
            document
              .getElementById(elementlist[i].elements[0].id)
              .addEventListener("click", () => {
                console.log(form);
                setelement(elementlist[i]);
                setshowDialog(true);
              });
          }
          for (let i = 0; i < btns.length; i++) {
            if (btns[i].innerText.includes("Submit")) {
              submitBtn = btns[i];
              btns[i].style.backgroundColor = "#003366";
              btns[i].style.color = "white";
              btns[i].style.width = "100%";
              btns[i].style.borderRadius = "5px";
              submitBtndata.current = btns[i];
              // setsubmitBtndata(submitBtn);
              const newDiv = document.createElement("div");
              newDiv.classList.add("back-div"); // Optionally add a class to the new div
              newDiv.style.position = "fixed";
              newDiv.style.width = "50%";
              newDiv.style.background = "white";
              newDiv.style.right = "0";
              newDiv.style.bottom = "0";
              newDiv.style.padding = "1rem";
              // Get the current parent of the button
              const currentParent = submitBtn.parentElement;

              if (currentParent) {
                // Insert the new div into the DOM at the button's position
                currentParent.insertBefore(newDiv, submitBtn);

                // Move the button into the new div
                newDiv.appendChild(submitBtn);
              }
            }
            if (btns[i].innerText.includes("Home")) {
              homeBtn = btns[i];
              btns[i].style.backgroundColor = "#ff0000";
              btns[i].style.color = "white";
              btns[i].style.width = "100%";
              btns[i].type = "button";
              btns[i].style.borderRadius = "5px";
              const newDiv = document.createElement("div");
              newDiv.classList.add("back-div"); // Optionally add a class to the new div

              newDiv.style.position = "fixed";
              newDiv.style.width = "50%";
              newDiv.style.background = "white";
              newDiv.style.left = "0";
              newDiv.style.bottom = "0";
              newDiv.style.padding = "1rem";
              // Get the current parent of the button
              const currentParent = homeBtn.parentElement;

              if (currentParent) {
                // Insert the new div into the DOM at the button's position
                currentParent.insertBefore(newDiv, homeBtn);

                // Move the button into the new div
                newDiv.appendChild(homeBtn);
              }
            }
          }

          if (submitBtndata.current) {
            submitBtndata.current.addEventListener("click", (event) => {
              const { data, errors } = form.current.submit();
              if (Object.keys(errors).length) {
                return;
              }
              if (
                data[SchemaPathNameDate.current] &&
                data[SchemaPathNameDate.current].formInputError
              ) {
                console.log(data[SchemaPathNameDate.current].formInputError);
                setdisplayWarning(true);
                setMessage(data[SchemaPathNameDate.current].formInputError);
                return;
              }
              let schemapathdata = {
                ...data[SchemaPathNameDate.current],
                ...OrgSalary.current,
              };
              let vardata = {
                ...data,
                [SchemaPathNameDate.current]: schemapathdata,
              };
              console.log(
                vardata[SchemaPathNameDate.current].salaryIncome <
                  vardata[SchemaPathNameDate.current].minMonthlySalary,
              );
              if (
                vardata[SchemaPathNameDate.current].salaryIncome <
                vardata[SchemaPathNameDate.current].minMonthlySalary
              ) {
                setdisplayWarning(true);
                setMessage(
                  `Salary Income is not eligible for the application (minimum ${vardata[SchemaPathNameDate.current].minMonthlySalary}).`,
                );
                return;
              }
              // return;
              completeTaskObj.current = {
                formData: {
                  ...vardata,
                  go_next: true,
                  elastic_count: countdata.current,
                },
                instance: InstanceKey,
              };
              completetask(
                { ...vardata, go_next: true, elastic_count: countdata.current },
                InstanceKey,
              );
            });
          }

          if (homeBtn) {
            homeBtn.addEventListener("click", (event) => {
              setshowExit(true);
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setdisplayWarning(true);
        setMessage("MSG");
        setStatus("error");
      })
      .finally(() => {
        setShowloader(false);
      });
  };
  const backtohome = () => {
    exit();
  };
  const retrySubmit = () => {
    console.log(completeTaskObj);
    console.log("rerty called");
    setMessage("");
    setshowretry(false);
    // completeTaskObj.current={formData:{ ...vardata, go_next: true,elastic_count:countdata.current },instance:InstanceKey};
    completetask(
      { ...completeTaskObj.current.formData },
      completeTaskObj.current.instance,
    );
  };
  const handleUppercaseInputs = (res) => {
    res.form?.components[0].components.map((component) => {
      if (component.type == "textfield" && component?.properties?.letterCase) {
        const inputs = document.getElementsByTagName("input");
        for (let i = 0; i < inputs.length; i++) {
          if (
            inputs[i].id.includes(component.id) &&
            inputs[i].type !== "date" &&
            inputs[i].type !== "hidden"
          ) {
            inputs[i].addEventListener("input", (event) => {
              if (component?.properties?.letterCase === "upper") {
                inputs[i].value = event.target.value.toUpperCase();
              }
            });
          }
        }
      } else if (component.type == "datetime") {
        const inputs = document.getElementsByTagName("input");
        for (let i = 0; i < inputs.length; i++) {
          if (
            inputs[i].type == "hidden" &&
            inputs[i].id.includes(component.id)
          ) {
            const parentDiv = inputs[i].parentElement;
            const dateInput = parentDiv.querySelector('input[type="date"]');
            if (dateInput) {
              const curr_year = new Date().getFullYear();
              const curr_date = new Date().getDate();
              const curr_month = new Date().getMonth() + 1;
              dateInput.setAttribute("min", "1949-12-12");

              dateInput.setAttribute(
                "max",
                `${curr_year}-${("0" + curr_month).slice(-2)}-${(
                  "0" + curr_date
                ).slice(-2)}`,
              );
            }
          }
        }
      }
    });
  };
  const completetask = (data, Instanckekey) => {
    setShowloader(true);
    let reqbody = {
      ...data,
    };
    axios
      .post(`${ApiUrl.CompleteTask}${Instanckekey}`, reqbody, {
        headers: {
          Authorization: `${sessionStorage.getItem("CORESESSION")}`,
        },
      })
      .then((resp) => {
        let schemadata = resp.data.items[0];
        getformschema(
          schemadata.processDefinitionKey,
          schemadata.processInstanceKey,
          undefined,
        );
      })
      .catch((err) => {
        setShowloader(false);
        setdisplayWarning(true);
        setMessage("MSG");
        setStatus("error");
      });
  };
  const callbkfn = async (data) => {
    console.log(formVar[SchemaPathName], data, element);
    OrgSalary.current = {
      ...OrgSalary.current,
      minMonthlySalary: data.Min_Monthly_Salary,
    };
    let formdata = { ...formVar[SchemaPathName], [element["key"]]: data.Name }; //,"salaryIncome":data.Min_Monthly_Salary
    let allVar = { ...formVar, [SchemaPathName]: formdata };
    console.log(allVar);
    setformVar({ ...allVar });
    ObjRef.current = { ...allVar };
    getformschema(DefinationKey, InstanceKey, 1);

    setshowDialog(false);
  };

  useEffect(() => {
    form.current = new Form({
      container: document.querySelector("#form"),
    });
    console.log(form);
    token = searchParams.get("token");
    featurename = searchParams.get("featurename");
    bankcode = searchParams.get("bankCode");
    setAuthorizationtoken(token);
    sessionStorage.setItem("CORESESSION", token);
    // setShowloader(true);
    // startprocessinstance('Kotak_PL');
    startprocessinstance("Kotak_PL_V1");
  }, []);
  const closeFn = () => {
    setshowDialog(false);
  };
  return (
    // <MyProvider>
    <div className="App">
      <div id="form"></div>
      {display ? (
        <Alert status={status} dataPass={dataobj} closedialog={closediv} />
      ) : null}
      {displayWarning ? (
        <Warning message={message} closeWarning={closeWarning} />
      ) : null}
      {showloader ? <LoadingAnimation /> : null}
      <button style={{ display: "none" }} id="home_btn">
        Click
      </button>
      <ConfirmationDialogRaw
        callbk={callbkfn}
        element={element}
        open={showDialog}
        onClose={closeFn}
      />
      {showExit ? (
        <div className="exitMain">
          <div className="exitCls">
            <span
              style={{
                fontWeight: "700",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Are you sure ?
            </span>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#ff0000",
                  color: "white",
                  fontWeight: "600",
                  width: "40%",
                }}
                onClick={backtohome}
              >
                Yes
              </Button>
              <Button
                style={{
                  backgroundColor: "#003366",
                  color: "white",
                  fontWeight: "600",
                  width: "40%",
                }}
                onClick={() => setshowExit(false)}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      ) : null}
      {showretry ? (
        <div className="dialogcls">
          <img src="/error.png" />
          <span style={{ fontWeight: "800", fontSize: "large" }}>
            Sorry,Try Again ?
          </span>
          <div
            style={{
              display: "flex",
              gap: "5px",
              width: "100%",
              margin: "10px",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <span>Error message:</span>
            <span style={{ fontWeight: "700" }}>{message ?? "N/A"}</span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              width: "100%",
            }}
          >
            <button
              style={{
                width: "40%",
                backgroundColor: "#003366",
                padding: "10px",
                color: "white",
              }}
              onClick={backtohome}
            >
              Home
            </button>
            <button
              style={{
                width: "40%",
                backgroundColor: "#ff0000",
                padding: "10px",
                color: "white",
              }}
              onClick={retrySubmit}
            >
              Retry
            </button>
          </div>
        </div>
      ) : null}
    </div>
    // </MyProvider>
  );
}

export default App;
